if (!customElements.get("m-slideshow")) {
  class MSlideshow extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.autoplay = this.dataset.autoplay === "true";
      this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed);
      this.showArrows = this.dataset.enableArrows === "true";
      this.showDots = this.dataset.enableDots === "true";
      this.adaptHeight = this.dataset.slideHeight === "adapt";
      this.enableLoop = "true" === this.dataset.enableLoop;
      this.enableThumbs = "false" === this.dataset.enableThumbs;
      this.id = this.dataset.id;
      this.sliderContainer = this.querySelector(".swiper-container");
      this.sliderThumbs = this.querySelector(".swiper-thumbs");
      this.effect = this.dataset.effect;
      this.perview = parseFloat(this.dataset.perview);
      this.mobilePerview = parseFloat(this.dataset.mobilePerview);
      this.width = parseInt(this.dataset.width) || undefined;
      this.center = "true" === this.dataset.center;
      this.spaceBetween = parseInt(this.dataset.spaceBetween);
      this.freeMode = "true" === this.dataset.freeMode;
      this.paginationType = this.dataset.paginationType;

      this.lastVideo = null;
      this.lastActive = null;
      this.timeout = null;
      this.initSlider();
    }

    initSlider() {
      this.slider = new ThemeLibs.Swiper(this.sliderContainer, {
        init: false,
        autoplay: this.autoplay
          ? {
            delay: this.autoplaySpeed * 1000,
            disableOnInteraction: true,
          }
          : false,
        slidesPerView: this.mobilePerview ? this.mobilePerview : 1,
        centeredSlides: this.center,
        slidesPerGroup: 1,
        loop: this.enableLoop,
        effect: this.effect || 'fade',
        fadeEffect: {
          crossFade: true,
        },
        freeMode: this.freeMode && {
          enabled: !0,
          momentum: 0,
        },
        spaceBetween: this.spaceBetween || 0,
        speed: 1000,
        navigation: this.showArrows
          ? {
            nextEl: this.querySelector(".m-slider-controls__button-next"),
            prevEl: this.querySelector(".m-slider-controls__button-prev"),
          }
          : false,
        pagination: this.showDots
          ? {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
            bulletClass: "m-dot",
            bulletActiveClass: "m-dot--active",
          }
          : false,
        breakpoints: {
          480: {
            slidesPerView: this.mobilePerview || 1,
            width: undefined
          },
          768: {
            slidesPerView: this.perview > 3 ? this.perview - 1 : this.perview || 1,
            threshold: 2.2,
            width: this.width
          },
          1024: {
            slidesPerView: this.perview || 1,
            threshold: 2.2,
            width: this.width
          }
        },
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });

      this.lastSlide = null;
      this.currentSlide = null;
      this.slider && this.slider.on("init", this.handleChange.bind(this));
      this.slider && this.slider.on("slideChange", this.handleChange.bind(this));
      this.slider.init();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
      }
    }

    handleChange(swiper) {
      const { activeIndex, slides } = swiper;
      const slideType = slides[activeIndex] && slides[activeIndex].dataset.slideType;
      this.lastActive && this.slider.slideToLoop(this.lastActive);
      if (slideType === "video_slide") {
        const video = slides[activeIndex] && slides[activeIndex].querySelector("video");

        if (video) {
          let playPromise = video.play();
          this.lastVideo && this.lastVideo.pause();
          if (playPromise !== undefined) {
            playPromise.then(() => {
              this.lastVideo = video;
            });
          }
        }
      } else {
        this.lastVideo && this.lastVideo.pause();
        this.lastVideo = null;
      }
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-slideshow", MSlideshow);
}
